import React, { useEffect, useState, useCallback } from "react";
import { Plus, Trash2, X } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminUsers() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "" });

  const load = useCallback(() => { api.get("/admin/users").then(({ data }) => setUsers(data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    try {
      await api.post("/admin/users", form);
      toast.success("Admin added"); setShow(false); setForm({ email: "", password: "", name: "" }); load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Remove this admin?")) return;
    try { await api.delete(`/admin/users/${id}`); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const inputCls = "w-full bg-[#141414] border border-[#333] rounded-lg h-11 px-3 text-[#F0EDEA] focus:border-[#E60000] outline-none mb-3";

  return (
    <div data-testid="admin-users">
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-heading font-black uppercase text-xl text-[#F0EDEA]">Admin Users</h1>
        <button onClick={() => setShow(true)} className="btn-skew btn-primary text-xs" data-testid="add-admin-btn"><span><Plus size={16} /> Add</span></button>
      </div>
      <div className="space-y-2">
        {users.map((u) => (
          <div key={u.id} className="bg-[#1C1C1C] border border-[#333] rounded-xl px-4 py-3 flex items-center justify-between" data-testid={`admin-user-${u.id}`}>
            <div>
              <div className="text-[#F0EDEA] font-semibold">{u.name}</div>
              <div className="text-[#A8A2A0] text-xs">{u.email}{u.id === user?.id && " (you)"}</div>
            </div>
            {u.id !== user?.id && <button onClick={() => remove(u.id)} className="text-[#A8A2A0] hover:text-[#E60000]"><Trash2 size={16} /></button>}
          </div>
        ))}
      </div>

      {show && (
        <div className="fixed inset-0 z-[70] bg-black/80 flex items-center justify-center p-4" data-testid="add-admin-modal">
          <div className="bg-[#111] border border-[#333] rounded-2xl p-5 w-full max-w-sm">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-heading font-bold uppercase text-[#F0EDEA]">New Admin</h2>
              <button onClick={() => setShow(false)} className="text-[#A8A2A0]"><X size={22} /></button>
            </div>
            <input className={inputCls} placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="new-admin-name" />
            <input className={inputCls} placeholder="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="new-admin-email" />
            <input className={inputCls} placeholder="Password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="new-admin-password" />
            <button onClick={add} className="btn-skew btn-primary w-full text-sm" data-testid="save-admin-btn"><span>Create Admin</span></button>
          </div>
        </div>
      )}
    </div>
  );
}
